export default {
  '百科内容':'Wiki Content',
  '百科视频':'Wiki Video',
  '请上传视频':'Upload Video',
  '请上传PDF文件':'Upload PDF File',
  '预览':'Preview',
  '仅支持扩展名pdf：':'Max 50MB (.pdf)',
  '分类列表':'Category List',
  '新增分类':'Add Category',
  '新增':'Add',
  '编辑分类':'Edit Category',
  '确认要删除该分类吗？':'Confirm to delete this category?',
  '分类删除成功！':'Category deleted successfully!',
  '分类名称':'Category Name',
  '分类名称已存在':'Category name already exists',
  '一级分类名称':'Primary Category Name',
  '二级分类名称':'Secondary Category Name',
  '编辑分类成功！':'Category edited successfully!',
  '新增分类成功！':'Category added successfully!',
  '资源内容':'Resource Content',
  '百科标题':'Wiki Title',
  '视频列表':'Video List',
  '支持上传mp4格式':'Supports mp4 format, max 1GB.',
  '视频':'Video',
  '标题':'Title',
  '简介':'Introduction',
  '添加视频':'Add Video',
  '编辑视频':'Edit Video',
  '添加视频':'Add Video',
  '视频标题':'Video Title',
  '描述':'Description',
  '视频上传中，是否取消？':'Are you sure to cancel the upload?',
  '确认要删除该视频吗？':'Confirm to delete this video?',
  '视频删除成功！':'Video deleted successfully!',
  '序号':'No.',
  '请输入分类名称搜索':'Please enter a category name to search',
  '导入分类':'Import Category',
  '分类导入完成':'Category import completed',
  '分类导入模板':'Category import template',
}
